import { ColorScheme, SizeType } from '@/types'
import { Tabs, type TabsProps } from '@chakra-ui/react'
import React from 'react'

interface Props extends TabsProps {
  variant?: 'line' | 'rounded',
  size?: SizeType,
  colorScheme?: ColorScheme
}


const Component = React.forwardRef((props: Props, ref: React.Ref<any>) => {
  return (
    <Tabs ref={ref} isFitted={true} { ...props } />
  )
})

export {
  Component as Tabs,
  type Props as TabsProps
}